import React, { useEffect, useState } from "react";
import Select from "react-select";

const MultiSelectElement = ({
  options,
  value,
  handleChange,
  placeholder = "Select",
  allowMenuOverflow = false,
}) => {
    
  const customStyles = {
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
    control: (base, state) => ({
      ...base,
      borderColor: state.isFocused ? "#8AAED6" : "lightgray",
      "&:hover": {
        borderColor: state.isFocused ? "#0a56ae" : "lightgray",
      },
      backgroundColor: state.isDisabled ? "#EFF2F7" : "base.backgroundColor",
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: state.isDisabled ? "black !important" : provided.color,
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 99999,
    }),
  };

  return (
    <div>
      <Select
        isMulti
        value={value}
        options={options}
        onChange={handleChange}
        placeholder={placeholder}
        className="basic-multi-select"
        classNamePrefix={"select"}
        {...(allowMenuOverflow && { menuPortalTarget: document.body })}
        styles={
          allowMenuOverflow
            ? customStyles
            : { ...customStyles, menuPortal: undefined }
        }
      />
    </div>
  );
};

export default MultiSelectElement;
